<p>
  <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="handleExportToExcelClick()" [disabled]="isExporting">
    <wl-busy *ngIf="isExporting" [show]="isExporting"></wl-busy>
    <span [hidden]="isExporting">{{ 'common.export' | translate | titlecase }}</span>
    <span [hidden]="!isExporting">{{ 'common.exporting' | translate | titlecase }}</span>
  </button>
</p>

<p-table [showGridlines]="true"
  [rows]="20"
  styleClass="wl-responsive-prime-datatable"
  [value]="recipientResult.Result"
  [paginator]="true"
  (onLazyLoad)="lazyLoad($event)"
  [totalRecords]="recipientResult.TotalCount"
  [lazy]="true"
  [loading]="isSearching"
>
  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    <SortAltIcon *ngIf="sortOrder === 0">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
    </SortAltIcon>
    <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
    </SortAmountUpAltIcon>
    <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
    </SortAmountDownIcon>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th [pSortableColumn]="'ProfileId'" class="wl-prime-datatable-hidden-phone" style="width: 120px">
        {{ 'communications.mass-comm-message-edit.analytics.delivery-details.profile-id-column-header' | translate | titlecase }}
        <p-sortIcon></p-sortIcon>
      </th>
      <th [pSortableColumn]="'SendToDisplayName'">
        {{ 'communications.mass-comm-message-edit.analytics.delivery-details.recipient-name-column-header' | translate | titlecase }}
        <p-sortIcon></p-sortIcon>
      </th>
      <th [pSortableColumn]="'SendTo'" class="wl-prime-datatable-hidden-phone">
        {{ 'communications.mass-comm-message-edit.analytics.delivery-details.email-column-header' | translate | titlecase }}
        <p-sortIcon></p-sortIcon>
      </th>
      <th [pSortableColumn]="'EmailResponse'" class="wl-prime-datatable-hidden-phone" style="width: 180px">
        {{ 'communications.mass-comm-message-edit.analytics.delivery-details.result-column-header' | translate | titlecase }}
        <p-sortIcon></p-sortIcon>
      </th>
      <th [pSortableColumn]="'TotalRead'" class="wl-prime-datatable-hidden-phone text-center" style="width: 180px">
        {{ 'communications.mass-comm-message-edit.analytics.delivery-details.read-count-column-header' | translate | titlecase }}
        <p-sortIcon></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-recipient>
    <tr>
      <td class="wl-prime-datatable-hidden-phone">
        {{ recipient.ProfileId }}
      </td>
      <td>
        <div class="wl-prime-datatable-hidden-phone">{{ recipient.SendToDisplayName }}</div>
        <div class="wl-prime-datatable-hidden-tablet-and-bigger">
          <div>
            <strong
              >{{
                'communications.mass-comm-message-edit.analytics.delivery-details.profile-id-column-header' | translate | titlecase
              }}:</strong
            >
            {{ recipient.ProfileId }}
          </div>
          <div>
            <strong
              >{{
                'communications.mass-comm-message-edit.analytics.delivery-details.recipient-name-column-header' | translate | titlecase
              }}:</strong
            >
            {{ recipient.SendToDisplayName }}
          </div>
          <div>
            <strong
              >{{ 'communications.mass-comm-message-edit.analytics.delivery-details.email-column-header' | translate | titlecase }}:</strong
            >
            {{ recipient.SendTo }}
          </div>
          <div>
            <strong
              >{{
                'communications.mass-comm-message-edit.analytics.delivery-details.result-column-header' | translate | titlecase
              }}:</strong
            >
            <span
              [ngClass]="{
                'wl-chart-text-green': recipient.EmailResponse == 'Email Sent',
                'wl-chart-text-red': recipient.EmailResponse == 'Email Failed',
              }"
              >{{ recipient.EmailResponse }}</span
            >
          </div>
          <div>
            <strong
              >{{
                'communications.mass-comm-message-edit.analytics.delivery-details.read-count-column-header' | translate | titlecase
              }}:</strong
            >
            {{ recipient.TotalRead }}
          </div>
        </div>
      </td>
      <td class="wl-prime-datatable-hidden-phone">
        <div style="overflow: hidden">{{ recipient.SendTo }}</div>
      </td>
      <td class="wl-prime-datatable-hidden-phone">
        <span
          [ngClass]="{
            'wl-chart-text-green': recipient.EmailResponse == 'Email Sent',
            'wl-chart-text-red': recipient.EmailResponse == 'Email Failed',
          }"
          >{{ recipient.EmailResponse }}</span
        >
      </td>
      <td class="wl-prime-datatable-hidden-phone text-center">
        {{ recipient.TotalRead }}
      </td>
    </tr>
  </ng-template>
</p-table>
